module.exports = __webpack_public_path__ + "static/media/vip7.44544867.png";